import { types } from 'mobx-state-tree'
import {
  wishlist__get,
  wishlist__attach_experience,
  wishlist__detach_experience
} from '../api/wishlist'
import object_value from '../api/object_value'
import { NotificationManager } from 'react-notifications'

function is_in_wishlist (result, experience_id) {
  let wishlist_experiences = object_value(result, 'data.experiences')
  if (!wishlist_experiences || !experience_id) {
    return false
  }
  return !!wishlist_experiences.find(obj => {
    return obj.id.toString() === experience_id.toString()
  })
}

const WishlistStore = types.model({
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get (token) {
      self.loaded = false
      wishlist__get(token).then(
        self.fetch
      )
    },
    fetch (data) {
      self.data = data
      self.loaded = true
    },
    clean () {
      self.data = false
      self.loaded = false
    },
    async attach_experience (experience_id, token) {
      let result = await wishlist__attach_experience(experience_id, token).then(result => {
        console.log('WishlistStore - attach_experience - result:', result)

        if (!result.ok) {
          let message = object_value(result, 'data.message', 'Error')
          NotificationManager.error(message, 'Error!', 5000)
        } else {
          NotificationManager.success('The experience has been added to your wishlist', 'Done', 2500)
        }
      })
      await self.get(token)
      return is_in_wishlist(result, experience_id)
    },
    async detach_experience (experience_id, token) {
      let result = await wishlist__detach_experience(experience_id, token).then(result => {
        console.log('WishlistStore - detach_experience - result:', result)

        if (!result.ok) {
          let message = object_value(result, 'data.message', 'Error')
          NotificationManager.error(message, 'Error!', 5000)
        } else {
          NotificationManager.success('The experience has been removed from your wishlist', 'Done', 2500)
        }
      })
      await self.get(token)
      return is_in_wishlist(result, experience_id)
    }
  })
)

export default WishlistStore



// WEBPACK FOOTER //
// ./src/stores/WishlistStore.js